import styled from '@emotion/styled';
import MBDialog from 'components/Elements/MBDialog';
import { Typography } from 'components/Typography';
import { theme } from 'theme';
import palette from 'theme/palette';
import pxToEm from 'theme/pxToEm';

export const AskProductModalView = styled(MBDialog)`
  ${theme.breakpoints.down('lg')} {
    display: none;
  }

  & #close_modal_button {
    right: ${pxToEm(16)};
    top: ${pxToEm(16)};

    &:hover {
      background-color: ${palette.secondary?.main};
    }
  }

  & .MuiDialog-container > .MuiPaper-root {
    box-shadow: none;
    padding-bottom: ${pxToEm(32)};
    padding-top: ${pxToEm(64)};
    background: ${palette.common.white};

    & .MuiDialogContent-root {
      padding-top: 0;
      padding-right: ${pxToEm(32)};
      margin-bottom: 0;
    }

    & .MuiDialogActions-root {
      & .MuiButton-containedPrimary:hover {
        background-color: ${palette.grey['A700']};
      }
    }
  }
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${pxToEm(16)};
`;

export const Title = styled(Typography)`
  text-align: center;
  line-height: 1.1;
`;

export const Subtitle = styled(Typography)`
  text-align: center;
  color: ${palette.grey['A400']};
`;
